module.exports = __webpack_public_path__ + "static/smls-logo-96ba5809e7bf92bb26ab1c8d56eb512d.png";